var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btns"},[_c('el-button',{class:{ active: _vm.isCollect},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.collect}},[_c('i',{staticClass:"el-icon-star-off mr2"}),_vm._v(_vm._s(_vm.isCollect ? '已收藏' : '收藏'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }